import { useI18next } from "@herob191/gatsby-plugin-react-i18next";

export function optionalDate(date) {
	// If a valid date is passed, returns it as Date object. Else, it returns current time as Date object
	if (date) {
		const d = new Date(date);
		if (isNaN(d.getTime())) {
			throw new Error("Wrong date passed");
		}
		return d;
	}
	return new Date();
}

export function getDayOfWeek(date) {
	return (date?.getDay() + 6) % 7; // getDay default is 0=Sun, this shifts it so 0=Mon
}

export function getHoursForRestaurantDate(restaurant = {}, date) {
	const d = optionalDate(date);
	return restaurant.frontmatter.hours[getDayOfWeek(d)];
}

export function getHour(hour = "HH:MM") {
	return parseInt(hour.split(":")[0], 10);
}

export function formatHours(
	hours = [
		["HH:MM", "HH:MM"],
		["HH:MM", "HH:MM"],
	]
) {
	return hours.map((arr) => `${arr[0]}-${arr[1]}`).join(" ");
}

export function toHourString(hour = 1) {
	return String(hour).padStart(2, "0");
}

// Treats over midnight hours as 24 + hour for proper calculation. Ex 01:30 is returned as 25:30
export function overMidnightFix(firstHourOfDay = 1, hour = 0) {
	let firstH = firstHourOfDay;
	let h = hour;

	// In case we get HH:MM strings insted of H int, we process them and return a string aswell
	if (typeof firstHourOfDay === "string" && typeof hour === "string") {
		firstH = parseInt(firstHourOfDay.split(":")[0], 10);
		h = parseInt(hour.split(":")[0], 10);

		return toHourString(firstH > h ? 24 + h : h) + ":" + hour.split(":")[1];
	}

	return firstHourOfDay > hour ? 24 + hour : hour;
}

export const weekDays = [
	{
		es: "L",
		en: "Mon",
	},
	{
		es: "M",
		en: "Tue",
	},
	{
		es: "M",
		en: "Wed",
	},
	{
		es: "J",
		en: "Thu",
	},
	{
		es: "V",
		en: "Fri",
	},
	{
		es: "S",
		en: "Sat",
	},
	{
		es: "D",
		en: "Sun",
	},
];

export default function useDayOfWeek(date) {
	const d = optionalDate(date);
	const { language } = useI18next();

	const dayOfWeek = getDayOfWeek(d);

	return weekDays[dayOfWeek][language] || weekDays[dayOfWeek]["es"];
}

export function collapseWeeklyHours(hoursArray = []) {
	const result = [];
	let currentGroup = null;

	for (let i = 0; i < hoursArray.length; i++) {
		const currentHours = hoursArray[i];

		// Convert hours to string for easy comparison
		const hoursStr = JSON.stringify(currentHours);

		if (currentGroup === null) {
			// Start a new group
			currentGroup = {
				dayStart: i,
				dayEnd: i,
				hours: currentHours,
			};
		} else if (JSON.stringify(currentGroup.hours) === hoursStr) {
			// Extend the current group
			currentGroup.dayEnd = i;
		} else {
			// Push the current group and start a new one
			result.push(currentGroup);
			currentGroup = {
				dayStart: i,
				dayEnd: i,
				hours: currentHours,
			};
		}
	}

	// Push the last group if it exists
	if (currentGroup !== null) {
		result.push(currentGroup);
	}

	return result;
}
